export const PERIOD_SCORE_MAP_QUERY = `
  query PeriodScoreMap($input: StandardCalendarNormDataInput!) {
    periodScoreMap(input: $input) {
      periodNorms {
        period
        values
      }
    }
  }
`;

export interface StandardCalendarNormDataInput {
  grade: number;
  districtId: string;
  schoolId: string;
  schoolYear: number;
  skillName: string;
  value: number[];
}

export interface PeriodNorm {
  period: string;
  values: number[];
}

export interface PeriodScoreMapResponse {
  periodScoreMap: {
    periodNorms: PeriodNorm[];
  };
} 